import { Radio as BaseRadio } from "@base-ui-components/react/radio";
import { RadioGroup as BaseRadioGroup } from "@base-ui-components/react/radio-group";
import { classed, clsx } from "@frend-digital/ui";
import type { ComponentProps, JSX } from "react";
import styles from "./Radio.module.css";

export const RadioRoot = classed(BaseRadio.Root, styles.Radio);
export const RadioGroup = classed(BaseRadioGroup, styles.Group);
export const Radio = classed(BaseRadio.Indicator, styles.Indicator);

export type RadioButtonProps = {
	label: string | JSX.Element;
	value: string | number;
	icon?: React.ReactNode;
	className?: string;
} & ComponentProps<typeof Radio>;

export const RadioButton = ({ label, value, icon, className, ...rest }: RadioButtonProps) => {
	return (
		// biome-ignore lint/a11y/noLabelWithoutControl: <explanation>
		<label className={clsx(styles.label, className)}>
			{icon && <div className={styles.icon}>{icon}</div>}
			<span>{label}</span>
			<RadioRoot value={value}>
				<Radio />
			</RadioRoot>
		</label>
	);
};
